import { RestSlice } from '../../../../../redux/rest.slice';
import { IppReportPackageTemplate } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippTemplateSlice = new RestSlice<IppReportPackageTemplate>(
	localizationService.getLocalizedString('ipp.reportPackage.templates.title'),
	Resource.IppReportPackageTemplates
);
export default ippTemplateSlice.rests.reducer;
